var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.691,
    height: 25.691,
    viewBox: "0 0 25.691 25.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info_3_",
    "data-name": "info (3)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3994",
    "data-name": "Group 3994",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5002",
    "data-name": "Path 5002",
    d: "M14.846,2A12.846,12.846,0,1,0,27.691,14.846,12.846,12.846,0,0,0,14.846,2Zm0,23.122A10.277,10.277,0,1,1,25.122,14.846,10.277,10.277,0,0,1,14.846,25.122Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 1,
    cy: 1.5,
    rx: 1,
    ry: 1.5,
    transform: "translate(12 6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5003",
    "data-name": "Path 5003",
    d: "M12.285,10A1.285,1.285,0,0,0,11,11.285v6.423a1.285,1.285,0,1,0,2.569,0V11.285A1.285,1.285,0,0,0,12.285,10Z",
    transform: "translate(0.561 0.277)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInfo);
export default __webpack_public_path__ + "static/media/whiteInfo.17dc69eaa6b747b6ebd86b065c93cea6.svg";
export { ForwardRef as ReactComponent };